import { CaretDownOutlined } from '@ant-design/icons';
import { TreeSelect } from 'antd';
import styled from 'styled-components';

const TreeSelectStyle = styled(TreeSelect)`
  display: flex;
  .ant-select-selector {
    font-size: 15px !important;
    width: 100%;
    padding: 0 !important;
    margin: 1.8px 0;
    border: none !important;
    background-color: transparent !important;
    box-shadow: none !important;
  }
  .ant-select-arrow .anticon:not(.ant-select-suffix) {
    pointer-events: none;
  }
  .ant-select-selection-search {
    width: 100%;
    inset-inline-start: 0 !important;
    inset-inline-end: 0 !important;
  }
`;

function FormTreeSelect (props) {
  return (
    <TreeSelectStyle
      treeDataSimpleMode
      suffixIcon={<CaretDownOutlined />}
      switcherIcon={<CaretDownOutlined />}
      filterTreeNode
      treeNodeFilterProp='title'
      showSearch
      treeLine={{
        showLeafIcon: false,
      }}
      showLine
      treeDefaultExpandAll={false}
      {...props}
    />
  );
};

export default FormTreeSelect;
